import type { TFunction } from 'i18next';
import type { EntityImportConfig, SkipReason } from './types';

export function importFieldLabel(t: TFunction, fieldname: string, fallback: string): string {
  return t(`import.fields.${fieldname}`, { defaultValue: fallback });
}

export function importSkipReason(t: TFunction, reason: SkipReason | undefined, config: EntityImportConfig): string {
  if (!reason) return '';
  return t(`import.skipReasons.${reason}`, {
    defaultValue: config.skipReasonLabels[reason] || String(reason),
  });
}

export function importEntityTitle(t: TFunction, config: EntityImportConfig): string {
  return t(`import.${config.entityId}.title`, { defaultValue: config.title });
}

export function importEntityDescription(t: TFunction, config: EntityImportConfig): string {
  return t(`import.${config.entityId}.description`, { defaultValue: config.description });
}
